import React from "react";
import InfoSection from "@components/pages/info/info_section";

function ServiceNumber() {
    return (
        <>
            <InfoSection>
                <p>
                    1819 leggur &aacute;herslu &aacute; a&eth; skapa eftirs&oacute;ttan
                    vinnusta&eth; &thorn;ar sem jafnr&eacute;tti er virt &iacute; hv&iacute;vetna.
                    1819 vill bj&oacute;&eth;a til starfa og halda h&aelig;fu og traustu
                    starfsf&oacute;lki. 1819 s&aelig;kist eftir &uacute;rvalsli&eth;i sem b&yacute;r
                    yfir mikilli &thorn;j&oacute;nustulund, samviskusemi og greiningarh&aelig;fni.
                    L&ouml;g&eth; er &aacute;hersla &aacute; a&eth; starfsf&oacute;lk s&eacute;
                    j&aacute;kv&aelig;tt, faglegt og frams&yacute;nt og leiti &aacute;vallt bestu
                    lausna fyrir vi&eth;skiptavininn.
                </p>
                <p>
                    1819 b&yacute;&eth;ur upp &aacute; hvetjandi og fr&aelig;&eth;andi
                    starfsumhverfi &thorn;ar sem einstaklingar f&aacute;i noti&eth;
                    sj&aacute;lfst&aelig;&eth;is og &aacute;byrg&eth;ar &iacute; starfi.
                    Markmi&eth;i&eth; er a&eth; styrkleikar hvers og eins f&aacute;i a&eth;
                    nj&oacute;ta s&iacute;n.
                </p>
                <p>
                    1819 hvetur starfsf&oacute;lk til opinna, hreinskiptinna og uppbyggilegra
                    samskipta &thorn;ar sem gagnkv&aelig;m vir&eth;ing r&iacute;kir auk
                    vir&eth;ingar vi&eth; samstarfsa&eth;ila og vi&eth;skiptavini. &THORN;&aacute;
                    er l&ouml;g&eth; &aacute;hersla &aacute; a&eth; allt starfsf&oacute;lk
                    stu&eth;li a&eth; g&oacute;&eth;um starfsanda, leggi sig fram vi&eth; a&eth;
                    efla li&eth;sheildina og sty&eth;ji hvert anna&eth;.
                </p>
            </InfoSection>
            <InfoSection title="Starfsf&oacute;lk">
                <table className="table">
                    <tbody>
                        <tr>
                            <td>
                                <b>Nafn</b>
                            </td>
                            <td>
                                <b>Netfang</b>
                            </td>
                        </tr>
                        <tr>
                            <td>&Aacute;g&uacute;sta Finnbogad&oacute;ttir</td>
                            <td>agusta@1819.is</td>
                        </tr>
                        <tr>
                            <td>Finnbogi Arnar Strange</td>
                            <td>finnbogi@1819.is</td>
                        </tr>
                        <tr>
                            <td>Halld&oacute;r J. &Aacute;rnason</td>
                            <td>halldor@1819.is</td>
                        </tr>
                    </tbody>
                </table>
            </InfoSection>
        </>
    );
}
export default ServiceNumber;
